export default "__VITE_ASSET__df91c044__"